import { render, staticRenderFns } from "./edit_zhengji.vue?vue&type=template&id=a047f222&scoped=true&"
import script from "./edit_zhengji.vue?vue&type=script&lang=js&"
export * from "./edit_zhengji.vue?vue&type=script&lang=js&"
import style0 from "./edit_zhengji.vue?vue&type=style&index=0&id=a047f222&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a047f222",
  null
  
)

export default component.exports